import { ResourcePage } from "./ResourcePage";

export function Websites() {
  return (
    <ResourcePage
      type="Website"
      typeLabelSentence="website"
      typeLabelPlural="websites"
      kindOptions={[]}
      defaultPort={443}
    />
  );
}
